function getOriginUrl(url) {
  const decodeUrl = decodeURIComponent(url);
  return decodeUrl === url ? url : getOriginUrl(decodeUrl);
}

export default class ParamsUtil {
  static addParamsKeepOldParams(url, params) {
    if (!params) {
      return url;
    }

    let oldParams = { ...params };
    let baseUrl = url;
    if (url.indexOf('?') > -1) {
      const s = url.split('?');
      baseUrl = s[0];
      const p = s[1];
      if (p) {
        p.split('&').forEach((i) => {
          const [k, v] = i.split('=');
          if (!!k && !!v) {
            oldParams[k] = v;
          }
        });
      }
    }

    if (oldParams) {
      const keys = Object.keys(oldParams);
      for (let index = 0; index < keys.length; index++) {
        const key = keys[index];
        const value = oldParams[key];

        baseUrl = `${baseUrl}${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    }
    return baseUrl;
  }

  static addParams(url, params) {
    let newUrl = url || '';
    Object.keys(params).forEach((key) => {
      if (params[key] === undefined || params[key] === null) {
        return;
      }
      if (newUrl.indexOf('?') > newUrl.indexOf('#')) {
        // 已经有query并且属于hash中的, 或者仅有query
        newUrl = `${newUrl}&${key}=${encodeURIComponent(params[key])}`;
      } else {
        newUrl = `${newUrl}?${key}=${encodeURIComponent(params[key])}`;
      }
    });
    return newUrl;
  }

  static getParams(url) {
    const params = {};
    const search = url.split('?')[1];
    if (search) {
      const parts = search.split('&');
      for (let i = 0; i < parts.length; i++) {
        const nv = parts[i].split('=');
        if (nv[0]) {
          params[nv[0]] = nv[1] || true;
        }
      }
    }
    return params;
  }

  static removeParams(keyName, urlStr) {
    // eslint-disable-next-line
    const name = keyName.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*(&|#|$))|&|#|$)`);
    return urlStr.replace(regex, (item) => {
      if (/^\?/.test(item)) {
        return '?';
      }
      if (/^&.+&$/.test(item)) {
        return '&';
      }
      if (/#$/.test(item)) {
        return '#';
      }
      return '';
    });
  }

  static get(keyName, url) {
    const urlStr = url || window.location.href;
    const originUrl = getOriginUrl(urlStr);
    // eslint-disable-next-line no-useless-escape
    const name = keyName.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]'.concat(name, '(=([^&#]*)|&|#|$)'));
    const results = regex.exec(originUrl);
    if (!results) {
      return undefined;
    }
    if (!results[2]) {
      return undefined;
    }
    const res = decodeURIComponent(results[2].replace(/\+/g, ' '));
    if (res === 'false') {
      return false;
    }
    if (res === 'undefined') {
      return undefined;
    }
    if (res === 'true') {
      return true;
    }
    if (res && typeof res === 'number') {
      return Number(res);
    }
    return res;
  }

  /**
   * 特殊处理链接值带有+号特殊字符
   * @param originName
   * @param originUrl
   * @return {*}
   */
  static getTicket(originName, originUrl) {
    let url = originUrl;
    if (!url) {
      url = window.location.href;
    }
    url = `${getOriginUrl(url)}`;
    // eslint-disable-next-line
    const name = originName.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regexS = `[\\?&]${name}=([^&#]*)`;
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    if (results) {
      results[1] = results[1].replace(/\s+/g, '+');
    }
    return results == null ? null : results[1];
  }
}
